<template>
  <div class="format-history">
    <h2 class="title">
      {{ tipTit[0] }}{{ from === 'audit' ? tipTit[1] : tipTit[2] }}{{ tipTit[3] }}
      <span
        class="operate"
        @click="handleSpread"
      >
        <span
          v-if="spread"
          class="text"
        >
          {{ $t('message["1106"]') }}
        </span>
        <span
          v-else
          class="text"
        >
          {{ $t('message["1564"]') }}
        </span>

        <i
          v-if="spread"
          class="iconfont iconicon-test14"
        />
        <i
          v-else
          class="iconfont iconicon-test17"
        />
      </span>
    </h2>
    <div
      v-show="spread"
      class="module"
    >
      <div class="top">
        <p><label>{{ $t('message["582"]') }}：</label>{{ data.from_url }}</p>
        <p><label>{{ $t('message["580"]') }}IP：</label>{{ data.from_ip }}</p>
        <p><label>{{ $t('message["1170"]') }}：</label>{{ $moment(data.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</p>
        <p><label>{{ $t('message["1973"]') }}：</label>{{ data.from_agent || '- -' }}</p>
      </div>
      <div
        v-if="data.all && data.all.length"
        class="content clearfix"
      >
        <div
          v-for="(item, index) in data.all"
          :key="index"
          class="item clearfix"
        >
          <i
            v-if="item.ismatch"
            class="iconfont iconicon-test success-icon"
          />
          <i
            v-else
            class="iconfont iconicon-test1 fail-icon"
          />
          <span class="fieldkey">{{ item.fieldname }}：</span>
          <div class="value">
            <div
              v-if="item.fieldtype === 'select_tree'"
              :class="item.fieldtype"
            >
              <p>{{ item.fieldvalue && setSelectVal(item.fieldvalue.treedata, ',') }}</p>
              <p>{{ item.fieldvalue && item.fieldvalue.input }}</p>
            </div>
            <div
              v-else-if="item.fieldtype === 'area'"
              :class="item.fieldtype"
            >
              <p>{{ item.fieldvalue && setSelectVal(item.fieldvalue.code, '/') }}</p>

              <p>{{ item.fieldvalue && item.fieldvalue.address }}</p>
            </div>
            <div
              v-else-if="item.fieldtype === 'file'"
              :class="item.fieldtype"
              class="file-box"
            >
              <p
                v-for="(file, k) in item.fieldvalue"
                :key="k"
                @click="handleFileGallery(file, k)"
              >
                <a>{{ file.file_name || file.file_url }}</a>
              </p>
            </div>
            <div
              v-else-if="item.fieldtype === 'select' || item.fieldtype === 'radio' || item.fieldtype === 'checkbox'"
              :class="item.fieldtype"
            >
              {{ setSelectVal(item.fieldvalue, ',') }}
            </div>
            <div
              v-else-if="item.fieldtype === 'datetime'"
              :class="item.fieldtype"
            >
              {{ item.fieldvalue }}
            </div>
            <div
              v-else
              :class="item.fieldtype"
            >
              {{ item.fieldvalue }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormatHistory } from '@/services/universalForm'

export default {
  props: {
    formHistoryId: {
      type: [String, Number],
      default: () => { }
    }
  },

  data () {
    return {
      spread: false,
      data: {},
      fileIndex: null
    }
  },

  computed: {
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    tipTit () {
      return this.$t('message["1578"]').split('|')
    }
  },

  created () {
    if (this.formHistoryId) {
      this.getFormatHistory()
    }
  },

  methods: {
    handleSpread () {
      this.spread = !this.spread
    },
    async getFormatHistory () {
      const chain = await getFormatHistory()
      chain
        .params({
          formid: this.formHistoryId
          // formid: this.formHistoryId || 125
          // formid: this.formHistoryId || 115
        })
        .onSuccess(payload => {
          payload.all.forEach(item => {
            if (item.fieldtype === 'file' && Array.isArray(item.fieldvalue)) {
              item.fieldvalue.forEach(file => {
                file.description = file.name
                file.href = file.file_url
                file.title = this.$t('message["1304"]')
              })
            }
          })
          this.data = payload
        })
        .fetch()
    },
    setSelectVal (value = {}, separator = ',') {
      const values = Object.values(value) || []
      return values.join(separator)
    },
    handleFileGallery (item, k) {
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', item.fieldvalue, k)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.format-history {
  .title {
    padding: 12px;
    font-size: 14px;
  }
  h2 {
    .operate {
      .text {
        color: #5077aa;
      }
      i {
        color: #ccc;
      }
      float: right;
    }
  }
  .module {
    background-color: #fff;

    .top {
      padding: 12px;
      color: #333;
      font-size: 14px;
      border-bottom: solid 1px #ebebeb;
      label {
        width: 80px;
        text-align: right;
      }
      p {
        margin-bottom: 10px;
      }
    }
    .success-icon {
      color: #42c27e;
    }
    .fail-icon {
      color: #f6a953;
    }

    .content {
      margin-top: 20px;
    }
    .item {
      padding: 0 12px 28px;
      font-size: 14px;
      .iconfont {
        float: left;
      }
      .fieldkey {
        float: left;
        width: 80px;
        margin: 0 10px;
        text-align: right;
        color: #666;
      }
      .value {
        float: left;
        width: 220px;
        color: #333;
        .editor {
          width: 100%;
          height: 100px;
          padding: 10px;
          overflow: auto;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid rgba(214, 214, 214, 1);
        }
        .email {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
